import styled, { css } from 'styled-components';
import { SpanTypography } from 'app/shared/components/Typography/SpanTypography';

interface ICheckboxContainerStProps {
  disabled?: boolean;
  alignment?: 'self-start' | 'center';
}

export const CheckboxContainerSt = styled.label<ICheckboxContainerStProps>`
  display: flex;
  align-items: ${({ alignment }) => alignment};
  cursor: pointer;
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
`;

interface ICheckboxLabelStProps {
  disabled?: boolean;
  danger?: boolean;
}

export const CheckboxLabelSt = styled(SpanTypography).attrs({
  variant: 'body4',
})<ICheckboxLabelStProps>`
  display: block;
  line-height: 24px;
  color: ${({ disabled, danger, theme }) =>
    disabled
      ? theme.colors.neutral50
      : danger
      ? theme.colors.error500
      : theme.colors.neutral800};

  & > h2 {
    line-height: ${({ theme }) => theme.lineHeights.h2};
  }
`;

export const CheckboxSt = styled.input`
  position: absolute;
  right: 0;
  left: 0;
  visibility: hidden;
`;

interface ICheckboxBackgroundStProps {
  selected?: boolean;
  disabled?: boolean;
  squareSelect?: boolean;
  danger?: boolean;
}

export const CheckboxBackgroundSt = styled.span<ICheckboxBackgroundStProps>`
  display: flex;
  width: 1.5rem;
  height: 1.5rem;
  min-width: 1.5rem;
  align-items: center;
  justify-content: center;
  border: solid 0.125rem;
  margin-right: 0.5rem;
  border-color: ${({ disabled, danger, theme, selected }) =>
    disabled
      ? theme.colors.neutral50
      : danger
      ? theme.colors.error500
      : selected
      ? theme.colors.secondary
      : theme.colors.neutral300};
  background-color: ${({ theme }) => theme.colors.white};

  &::after {
    ${({ squareSelect, disabled, selected, theme }) =>
      squareSelect
        ? css`
            position: relative;
            display: ${() => (selected ? 'flex' : 'none')};
            width: 0.675rem;
            height: 0.675rem;
            background: ${theme.colors.secondary};
            content: '';
            border-width: unset;
          `
        : css`
            position: relative;
            bottom: 0.0625rem;
            display: ${selected ? 'flex' : 'none'};
            width: 0.375rem;
            height: 0.75rem;
            border: solid
              ${disabled ? theme.colors.neutral50 : theme.colors.secondary};
            content: '';
            border-width: 0 0.125rem 0.125rem 0;
            transform: rotate(45deg);
          `};
  }
`;
